import { InventoryLocation } from 'inventory-web'
import { heapEvent } from '@equipmentshare/heaper'

import AddInventoryLocationModal from './AddInventoryLocationModal'
import EditInventoryLocationModal from './EditInventoryLocationModal'
import SetDefaultInventoryLocationModal from './SetDefaultInventoryLocationModal'
import DeleteInventoryLocationModal from './DeleteInventoryLocationModal'
import MoveInventoryLocationModal from './MoveInventoryLocationModal'
import WarehouseSettingsModal from './WarehouseSettingsModal'

export function getAddInventoryLocationModal( onSuccess?: () => void ) {
	return {
		component: AddInventoryLocationModal,
		label: 'Add Store',
		onXClick: () => heapEvent( 'Inventory - Add Store Modal - Click - X button', {} ),
		onSuccess,
	}
}

export function getEditInventoryLocationModal( inventoryLocation: InventoryLocation, updateAfterEdit: ( updatedInventoryLocation: InventoryLocation ) => void, onSuccess?: () => void ) {
	return {
		component: EditInventoryLocationModal,
		componentProps: { inventoryLocation, updateAfterEdit },
		label: 'Edit Store',
		onXClick: () => heapEvent( 'Inventory - Edit Store Modal - Click - X button', {} ),
		onSuccess,
	}
}

export function getSetDefaultInventoryLocationModal( inventoryLocation: InventoryLocation, updateAfterEdit: ( updatedInventoryLocation: InventoryLocation, clearOtherDefaults?: boolean ) => void, onSuccess?: () => void ) {
	return {
		component: SetDefaultInventoryLocationModal,
		componentProps: { inventoryLocation, updateAfterEdit },
		label: 'Main Inventory',
		onXClick: () => heapEvent( 'Inventory - Set Default Store Modal - Click - X button', {} ),
		onSuccess,
	}
}

export function getDeleteInventoryLocationModal() {
	return {
		component: DeleteInventoryLocationModal,
		label: 'Delete Store',
		onXClick: () => heapEvent( 'Inventory - Delete Store Modal - Click - Cancel or X', {} ),
	}
}

export function getMoveInventoryLocationModal( inventoryLocation: InventoryLocation, updateAfterMove: ( oldInventoryLocationId: string, movedInventoryLocation: InventoryLocation, fromBranchId: number, toBranchId: number ) => void, onSuccess?: () => void ) {
	return {
		component: MoveInventoryLocationModal,
		componentProps: { inventoryLocation, updateAfterMove },
		label: 'Move to branch',
		onXClick: () => heapEvent( 'Inventory - Move Store Modal - Click - X button', {} ),
		onSuccess,
	}
}

export function getWarehouseSettingsModal( inventoryLocation: InventoryLocation, updateAfterEdit: ( updatedInventoryLocation: InventoryLocation ) => void ) {
	return {
		component: WarehouseSettingsModal,
		componentProps: { inventoryLocation, updateAfterEdit },
		label: `Warehouse settings: ${inventoryLocation.name}`,
		width: 560,
		onXClick: () => heapEvent( 'Inventory - Warehouse Settings Modal - Click - X button', {} ),
	}
}
